require("./bootstrap");

// Import npm packages
import sort from "@alpinejs/sort";
import Alpine from "alpinejs";
import Swal from "sweetalert2";
import TomSelect from "tom-select";
import { createTomSelect, syncTomSelectFields, installTomSelectFields } from "./components/tom-select";

// Make available globally
window.Swal = Swal;
window.TomSelect = TomSelect;
window.createTomSelect = createTomSelect;
window.syncTomSelectFields = syncTomSelectFields;
installTomSelectFields();

Alpine.plugin(sort);

window.Alpine = Alpine;
Alpine.start();


import feather from "feather-icons";

document.addEventListener("DOMContentLoaded", () => {
    feather.replace();
});

function truncateStr(description, maxLength) {
    return {
        description: description,
        maxLength: maxLength,
        truncatedDescription() {
            return this.description.length > this.maxLength
                ? this.description.substring(0, this.maxLength) + "..."
                : this.description;
        },
    };
}
$(document).ready(function () {});
